import React, { useState, useEffect } from "react";
import axios from "axios"
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  TextField,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Paper,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import FacebookIcon from "@mui/icons-material/Facebook";
import BaseURL from "./../api/AppURL";
import { useContext } from "react";
import ProfileContext from "../contexts/ProfileContext";

import {imgVendorBaseUrl} from "./../api/AppURL";



const initialData = {
  photo: "",
  name: "Admin Name",
  username: "vendoruser",
  email: "vendor@softenginebd.com",
  address: "Dhaka, Bangladesh",
  phone: "017XXXXXXXX",
  website: "https://softenginebd.com",
  facebook: "softenginebd",
};

export default function VendorProfile({ onSaveSuccess }) {
  const [vendorData, setVendorData] = useState(initialData);
  const [photoPreview, setPhotoPreview] = useState(vendorData.photo);
  const { setProfile } = useContext(ProfileContext);
  const [selectedPhotoName, setSelectedPhotoName] = useState("");
  // API থেকে ডাটা ফেচ করা
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("auth_token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const res = await axios.get(`${BaseURL}/vendor/profile`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (res.data && res.data.status && res.data.vendorData) {
          const apiData = res.data.vendorData;
          const photoUrl = apiData.photo ? imgVendorBaseUrl + apiData.photo : "";

          //...apiData হলো spread operator যা apiData অবজেক্টের 
          //সব প্রপার্টি/properties(যেমন: id, name, email, phone, photo ইত্যাদি) 
          // কে নতুন অবজেক্টের মধ্যে copy করে।
          //তারপর photo প্রপার্টি স্পেসিফিকালি ওভাররাইট করে দেয়া হবে photoUrl দিয়ে।
          //মানে, photo কে আগের apiData.photo (যা filename ছিল) থেকে পুরো URL এ পরিবর্তন 
          //করা হয়েছে 
          setVendorData({
            ...apiData,
            photo: photoUrl,
          });
          setPhotoPreview(photoUrl);
        }
      } catch (err) {
        console.error("Error fetching vendor profile:", err);
      }
    };

    fetchProfile();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVendorData((prev) => ({ ...prev, [name]: value }));

  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedPhotoName(file.name);
      const reader = new FileReader();
      reader.onload = (ev) => {
        setPhotoPreview(ev.target.result);
        setVendorData((prev) => ({ ...prev, photo: file }));

      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('name', vendorData.name);
    formData.append('email', vendorData.email);
    formData.append('phone', vendorData.phone || '');
    formData.append('address', vendorData.address || '');

    // photo যদি file হয় তাহলে পাঠাবে, না হলে পাঠাবে না
    if (vendorData.photo && vendorData.photo instanceof File) {
      formData.append('photo', vendorData.photo);
    }

    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.post(`${BaseURL}/vendor/profile/store`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        },
      });


      const successMessage = response.data.message || 'Profile updated successfully!';
      setProfile({
        name: response.data.vendor.name,
        email: response.data.vendor.email,
        photo: response.data.vendor.photo, // (API রেসপন্স থেকে)
      });
      localStorage.setItem("profile", JSON.stringify({
        name: response.data.vendor.name,
        email: response.data.vendor.email,
        photo: response.data.vendor.photo,
      }));
      // যদি তোমার কম্পোনেন্টে onSaveSuccess নামে প্রপস থাকে, তাহলে সেটাকে কল করো
      if (typeof onSaveSuccess === 'function') {
        onSaveSuccess(successMessage);

      } else {
        // নাহলে ডিফল্ট এলার্ট দেখাও
        alert(successMessage);
      }

      // চাইলে এখানে UI আপডেটও করো, যেমন setVendorData ইত্যাদি
    } catch (err) {
      console.error('Update error:', err);
      alert('Error updating profile. Try again!');
    }
  };


  return (
    <Box sx={{ bgcolor: "#f4f6fa", minHeight: "100vh" }}>
      <CssBaseline />
      <Container
        maxWidth="lg"
        sx={{
          mt: -2,
          mb: 2,
          p: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: { xs: 1, md: 2 },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 2,
            bgcolor: "#f4f6fa",
            boxShadow: "none",
            minHeight: 500,
            alignItems: "stretch",
            width: "100%",
            maxWidth: 900,
          }}
        >
          {/* Left Section: Profile Summary */}
          <Box
            sx={{
              flex: 1,
              bgcolor: "#fff",
              borderRadius: 2,
              boxShadow: 1,
              p: 2,
              minWidth: 260,
              maxWidth: 290,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Avatar
              src={photoPreview || "/no_image.jpg"}
              sx={{
                flex: 2,
                bgcolor: "#fff",
                borderRadius: 2,
                boxShadow: 1,
                p: { xs: 2, md: 3 },
                minWidth: 250,
                maxHeight: "600px", // Add this
                overflowY: "auto",  // Add this
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {vendorData.name}
            </Typography>
            <Typography color="text.secondary" sx={{ fontSize: 14 }}>
              Role: {vendorData.role}
            </Typography>
            <Typography color="text.secondary" sx={{ fontSize: 15 }}>
              {vendorData.email}
            </Typography>
            <Typography color="text.secondary" sx={{ fontSize: 14 }}>
              {vendorData.phone}
            </Typography>
            <Typography color="text.secondary" sx={{ fontSize: 14, mb: 2 }}>
              {vendorData.address}
            </Typography>
            <Divider sx={{ width: "100%", my: 2 }} />
            <List dense>
              <ListItem>
                <ListItemIcon>
                  <LanguageIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Website"
                  secondary={
                    vendorData.website ? (
                      <a
                        href={vendorData.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1976d2", textDecoration: "underline" }}
                      >
                        {vendorData.website}
                      </a>
                    ) : (
                      "-"
                    )
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <FacebookIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Facebook"
                  secondary={
                    vendorData.facebook ? (
                      <a
                        href={
                          vendorData.facebook.startsWith("http")
                            ? vendorData.facebook
                            : `https://facebook.com/${vendorData.facebook}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1976d2", textDecoration: "underline" }}
                      >
                        {vendorData.facebook}
                      </a>
                    ) : (
                      "-"
                    )
                  }
                />
              </ListItem>
            </List>
          </Box>

          {/* Right Section: Profile Edit */}
          <Box
            sx={{
              flex: 2,
              bgcolor: "#fff",
              borderRadius: 2,
              boxShadow: 1,
              p: { xs: 2, md: 4 },
              minWidth: 290,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
              Edit Profile
            </Typography>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid item xs={12}>
                  <TextField
                    label="User Name"
                    name="username"
                    value={vendorData.username}
                    fullWidth
                    disabled
                    InputProps={{
                      style: { backgroundColor: "#f5f5f5" },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Full Name"
                    name="name"
                    value={vendorData.name}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Email"
                    name="email"
                    value={vendorData.email}
                    onChange={handleChange}
                    type="email"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Phone"
                    name="phone"
                    value={vendorData.phone}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Address"
                    name="address"
                    value={vendorData.address}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Website"
                    name="website"
                    value={vendorData.website}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Facebook"
                    name="facebook"
                    value={vendorData.facebook}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flexWrap: "wrap"
                  }}>
                    <Button
                      variant="contained"
                      component="label"
                      sx={{ fontWeight: 600, mb: 1, backgroundColor: "#2196f3" }}
                    >
                      Browse Photo
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        name="photo"
                        onChange={handlePhotoChange}
                      />
                    </Button>
                    {/* ফাইলনেম দেখানো */}
                    {selectedPhotoName && (
                      <Typography variant="caption" sx={{ color: "#1976d2", maxWidth: 160, wordBreak: "break-all" }}>
                        {selectedPhotoName.length > 25
                          ? selectedPhotoName.slice(0, 22) + "..."
                          : selectedPhotoName}
                      </Typography>
                    )}
                    {/* ছবি প্রিভিউ */}
                    <Avatar
                      src={photoPreview || "/no_image.jpg"}
                      sx={{
                        width: 87, // ছোট করে রাখতে চান তো 65, বড় চাইলে 90
                        height: 87,
                        border: "2px solid #2196f3",
                        bgcolor: "#fff",
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ flexGrow: 1 }} />
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ px: 4, py: 1.2, fontWeight: 600, fontSize: 16, mt: 1 }}
                    fullWidth
                  >
                    Save Changes
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
